import styled from '@emotion/styled/macro'
import mediaQuery from 'share/utils/mediaQuery'
import { pageContentDefaultSize } from 'style/emotion'

const DoneContainer = styled('section')`
  ${pageContentDefaultSize}
  color: #173237;
  margin-top: 3rem;

  .done-header {
    font-size: 25px;
    font-weight: 300;
  }
  .done-description {
    font-size: 14px;
    font-weight: 400;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }
  .goto-summary-btn {
    width: 280px;
    margin: auto;
    ${mediaQuery('tablet')} {
      width: 100%;
    }
  }
  ${mediaQuery('tablet')} {
    margin-top: 1.5rem;
  }
`

export { DoneContainer }
